import React, { useState, useContext } from "react";
import { Text, View, TouchableOpacity, Pressable, Image, Modal, ScrollView, StyleSheet, Platform, ActivityIndicatorComponent } from "react-native";
import { ProductsContext } from "../context/ProductsContext";
import { CartContext } from "../context/CartContext";

const ProductElement = ({ item, setProductsTitle }) => {
    const { name, price, quantity, image } = item;
    const { setProducts, pushProducts, updateSelectedProducts, getVariations } = useContext(ProductsContext);
    const { inCart } = useContext(CartContext);
    const [modalVisible, setModalVisible] = useState(false);

    const productSelected = async (item, hasChildren, setProducts, setProductsTitle, pushProducts, setModalVisible) => {
        console.log("item: ", item);
        if (hasChildren) {
            setProductsTitle(item.name);
            if (item.children.length === 0) {
                item.children = await getVariations(item.id, item.name);
            }
            item.children = item.children.map(child => {
                return { ...child, quantity: inCart(child.id) };
            })
            pushProducts();
            setProducts(item.children);
        } else {
            setModalVisible(true);
        }
    }

    const ImageFromURL = { uri: image };
    const hasChildren = (item.variations && item.variations.length > 0);
    /*
    const ribbon = hasChildren ? require("../../assets/options-ribbon.png") : 
        item.stockStatus === 'outofstock' ? require("../../assets/unavailable-ribbon.png") : 
        item.stockStatus === 'onbackorder' ? require("../../assets/backorder-ribbon.png") : require("../../assets/info-ribbon.png");
    */
    const ribbon = hasChildren ? null : 
        item.stockStatus === 'outofstock' ? require("../../assets/unavailable-ribbon.png") : 
        item.stockStatus === 'onbackorder' ? require("../../assets/backorder-ribbon.png") : require("../../assets/info-ribbon.png");
    
    return (
        <View style={styles.productStyle}>
            <Modal
                animationType="fade"
                transparent={true}
                visible={modalVisible}
                onRequestClose={() => {
                    setModalVisible(false);
                }}>
                <ScrollView contentContainerStyle={styles.modalView}>
                    <Text style={styles.modalTitle}>{item.name}</Text>
                    <Image style={styles.modalImageStyle} source={ImageFromURL} />
                    {item.shortDescription && item.shortDescription.length > 0 &&
                        <Text style={styles.modalDescription}>{item.shortDescription}</Text>
                    }
                    <Text style={styles.modalDescription}>{item.description}</Text>
                    <Pressable
                        style={styles.modalButton}
                        onPress={() => setModalVisible(false)}>
                        <Text style={styles.modalButtonText}>Voltar</Text>
                    </Pressable>
                </ScrollView>        
            </Modal>
            <TouchableOpacity disabled={(item.stockStatus !== 'instock' && !hasChildren)} onPress={() => productSelected(item, hasChildren, setProducts, setProductsTitle, pushProducts, setModalVisible)}>
                <Image style={styles.imageStyle} source={ImageFromURL} />
                {ribbon &&
                    <Image style={styles.addRibbonStyle}source={ribbon} />
                }
                <Text style={styles.elementText}>{name}</Text>
                {!hasChildren && 
                    <Text style={[styles.elementText, styles.elementPrice]}>R$ {parseFloat(price).toFixed(2)}</Text>
                }
            </TouchableOpacity>
            {!hasChildren && (item.stockStatus === 'instock') && 
                <View style={styles.controlsViewStyle}>
                    <TouchableOpacity
                        onPress={() => {
                            if (item.quantity > 0) {
                                const newItem = { ...item, quantity: item.quantity - 1 };
                                updateSelectedProducts(newItem);
                            }
                        }}>
                        <Image style={styles.plusMinusIconStyle} source={require("../../assets/minus.png")} />
                    </TouchableOpacity>
                    <Text style={styles.qtyTextStyle}>{quantity}</Text>
                    <TouchableOpacity
                        onPress={() => {
                            const newItem = { ...item, quantity: item.quantity + 1 };
                            updateSelectedProducts(newItem);
                        }}>
                        <Image style={styles.plusMinusIconStyle} source={require("../../assets/plus.png")} />
                    </TouchableOpacity>
                </View>
            }
            {hasChildren && 
                <View style={{flexDirection: 'row'}}>
                    <TouchableOpacity style={styles.options}
                        onPress={() => productSelected(item, hasChildren, setProducts, setProductsTitle, pushProducts, setModalVisible)}>
                        <Text style={{fontWeight: 'bold', textAlign: 'center'}}>Opções</Text>
                    </TouchableOpacity>
                </View>
            }
        </View>
    );
};

const styles = StyleSheet.create({
    productStyle: {
        margin: 5
    },
    elementText: {
        fontSize: 14,
        textAlign: 'center',
        padding: 5,
        width: 107,
        backgroundColor: 'white',
    },
    elementPrice: {
        fontWeight: 'bold',
        marginBottom: 10,
        borderBottomLeftRadius: 10,
        borderBottomRightRadius: 10
    },
    options: {
        flex: 1,
        backgroundColor: '#F0A22E',
        marginVertical: 10,
        padding: 10,
        borderRadius: 10,
        alignSelf: 'center'
    },
    addRibbonStyle: {
        height: 80,
        width: 80,
        position: "absolute",
        marginTop: 0,
        marginLeft: 0
    },
    plusMinusIconStyle: {
        height: 25,
        width: 25,
    },
    imageStyle: {
        height: 107,
        width: 107,
        resizeMode: 'cover',
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10
    },
    controlsViewStyle: {
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        marginVertical: 5,
        display: "flex"
    },
    qtyButtonStyle: {
        width: 300
    },
    qtyTextStyle: {
        textAlign: 'center'    
    },
    modalView: {
        backgroundColor: "white",
        borderRadius: 10,
        margin: 10,
        alignSelf: "flex-start",
        paddingTop: 30,
        paddingBottom: 70,
        paddingHorizontal: 30, 
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5
    },
    modalTitle: {
        marginBottom: 15,
        fontSize: 24,
        fontWeight: 'bold'
    },
    modalImageStyle: {
        height: 240,
        width: 320,
        resizeMode: 'cover',
        borderRadius: 10
    },
    modalDescription: {
        marginTop: 15,
        fontSize: 16
    },
    modalButton: {
        backgroundColor: '#965E11',
        width: 250,
        marginTop: 10,
        paddingVertical: 10,
        borderRadius: 10,
        alignSelf: 'center',
        justifyContent: 'flex-end'
    },
    modalButtonText: {
        fontSize: 20,
        fontWeight: 'bold',
        alignSelf: 'center',
        color: 'white'
    },
});

export default ProductElement;